import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http'
import { ResourceService } from '@smartsoftware/reflex-core';
import { VendorMigrationMeta } from '../models/vendorMigrationMeta.model';
import { map } from 'rxjs/operators';

@Injectable()
export class VendorMigrationMeta_Service extends ResourceService<VendorMigrationMeta> {
    protected servicePath: string = '/VendorMigrationMeta';

    public ModelType = VendorMigrationMeta;

    constructor(
        protected http: HttpClient
    ) {
        super(http);
    }

    public getMigrationsByType(sync_type: string, job_type: string) {
        return this.http
            .post(
                `${this.serviceUrl}getMigrationsByType`,
                { sync_type: sync_type, job_type: job_type },
                { observe: 'response' }
            )
            .pipe(
                map(
                    (response: HttpResponse<any>) =>
                        response.body.map((e: any) => new VendorMigrationMeta(e))
                )
            );
    }
}
